import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';
import { createObservableDataAction, IAction, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';

export function createAddressSaveInput(result: string): GenericInput<string> {
    return new GenericInput<string>('AddressSave', result, 'string');
}

const createAddressSaveInputIternal = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return createAddressSaveInput('');
};

export default createObservableDataAction({
    action: <IAction<string>>getGenericAction,
    input: createAddressSaveInputIternal
});